import { render, staticRenderFns } from "./PricingPlansCompareTableSection.vue?vue&type=template&id=01903ca8&scoped=true&"
import script from "./PricingPlansCompareTableSection.vue?vue&type=script&lang=js&"
export * from "./PricingPlansCompareTableSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlansCompareTableSection.vue?vue&type=style&index=0&id=01903ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01903ca8",
  null
  
)

export default component.exports